import { Link } from 'react-router-dom';
import { Fragment, LegacyRef, useEffect, useRef, useState } from 'react';
import { useNavState } from '@/providers/NavStateProvider';
import { Notifications } from '@/components/layout/Nav/NavBar/Notifications';
import { UserMenu } from '@/components/layout/Nav/NavBar/UserMenu';
import { useDebouncedCallback } from 'use-debounce';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';

export const NavBar = () => {
  const { showSideNav, setShowSideNav, minimumSideNav, setMinimumSideNav, title, breadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  const navRef = useRef<HTMLElement>(null);
  const sideNavRef = useRef<HTMLElement>(null);
  const classes = ['blur', 'shadow-blur', 'left-auto'];
  const toggleClasses = [`shadow-none`];

  useEffect(() => {
    if (minimumSideNav) {
      document.body.classList.remove('g-sidenav-hidden');
      document.body.classList.remove('g-sidenav-pinned');
    } else {
      document.body.classList.add('g-sidenav-hidden');
      document.body.classList.add('g-sidenav-pinned');
    }
  }, [minimumSideNav]);

  useEffect(() => {
    const sideNav = document.getElementById('sidenav-main');

    if (sideNav) {
      if (showSideNav) {
        document.body.classList.add('g-sidenav-pinned');
        sideNav.classList.add('bg-white');
        sideNav.classList.remove('bg-transparent');
      } else {
        sideNav.classList.remove('bg-white');
        sideNav.classList.remove('bg-transparent');
        document.body.classList.remove('g-sidenav-pinned');
      }
    }
  }, [showSideNav]);

  const mainContentScrollEvent = useDebouncedCallback(() => {
    const nav = navRef.current!;

    if (window.scrollY > 5) {
      nav.classList.add(...classes);
      nav.classList.remove(...toggleClasses);
    } else {
      nav.classList.remove(...classes);
      nav.classList.add(...toggleClasses);
    }
  }, 10);

  useEffect(() => {
    window.addEventListener('scroll', mainContentScrollEvent);

    return () => window.removeEventListener('scroll', mainContentScrollEvent);
  }, []);

  return (
    <nav
      className="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 ms-2 me-4 shadow-none border-radius-xl z-index-sticky"
      id="navbarBlur"
      data-scroll="true"
      ref={navRef}
    >
      <div className="container-fluid py-1 px-3">
        <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none me-3">
          <Link to={''} className="nav-link text-body p-0" onClick={() => setMinimumSideNav(!minimumSideNav)}>
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
            </div>
          </Link>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm">
              <Link className="opacity-5 text-dark" to={`/w/${_w_!.identifier}`}>
                {_w_!.name}
              </Link>
            </li>
            {breadcrumbs.map((d, i) => (
              <Fragment key={`breadcrumbs-${i}`}>
                <li className="breadcrumb-item text-sm">
                  <Link className="opacity-5 text-dark" to={d.path}>
                    {d.label}
                  </Link>
                </li>
              </Fragment>
            ))}
          </ol>
          <h6 className="font-weight-bolder mb-0">{title}</h6>
        </nav>
        <ul className="navbar-nav ms-md-auto justify-content-end">
          <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
            <Link to="" className="nav-link text-body px-3" id="iconNavbarSidenav" onClick={() => setShowSideNav(!showSideNav)}>
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
              </div>
            </Link>
          </li>

          <Notifications />

          <UserMenu />
        </ul>
      </div>
    </nav>
  );
};
